import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currStep: 1,
    name: "",
    email: "",
    currentQuestion: 0,
    recordingIds: {},
    recordingTimes: {},
    mediaQuestion: "",
    videoFileNames: {},
    currentRecordedBlob: null,
    testimonialSubmitDisabled: false,
    role: -1,
    candidateName: "",
    recordings: [],
};

const testimonialSlice = createSlice({
    name: "testimonial",
    initialState,
    reducers: {
        setCurrStep: (state, action) => {
            state.currStep = action.payload;
        },
        setName: (state, action) => {
            state.name = action.payload;
        },
        setEmail: (state, action) => {
            state.email = action.payload;
        },
        setCurrentQuestion: (state, action) => {
            state.currentQuestion = action.payload;
        },
        setRecordingIds: (state, action) => {
            state.recordingIds = action.payload;
        },
        setRecordingTimes: (state, action) => {
            state.recordingTimes = action.payload;
        },
        setMediaQuestion: (state, action) => {
            state.mediaQuestion = action.payload;
        },
        setVideoFileNames: (state, action) => {
            state.videoFileNames = action.payload;
        },
        setCurrentRecordedBlob: (state, action) => {
            state.currentRecordedBlob = action.payload;
        },
        setTestimonialSubmitDisabled: (state, action) => {
            state.testimonialSubmitDisabled = action.payload;
        },
        setRole: (state, action) => {
            state.role = action.payload;
        },
        setCandidateName: (state, action) => {
            state.candidateName = action.payload;
        },
        setRecordings: (state, action) => {
            state.recordings = action.payload;
        },
    },
});

export const {
    setCurrStep,
    setName,
    setEmail,
    setCurrentQuestion,
    setRecordingIds,
    setRecordingTimes,
    setMediaQuestion,
    setVideoFileNames,
    setCurrentRecordedBlob,
    setTestimonialSubmitDisabled,
    setRole,
    setCandidateName,
    setRecordings,
    clearRecordings,
} = testimonialSlice.actions;

export const getCurrStep = (state) => state.testimonial.currStep;
export const getName = (state) => state.testimonial.name;
export const getEmail = (state) => state.testimonial.email;
export const getCurrentQuestion = (state) => state.testimonial.currentQuestion;
export const getRecordingIds = (state) => state.testimonial.recordingIds;
export const getRecordingTimes = (state) => state.testimonial.recordingTimes;
export const getMediaQuestion = (state) => state.testimonial.mediaQuestion;
export const getVideoFileNames = (state) => state.testimonial.videoFileNames;
export const getCurrentRecordedBlob = (state) => state.testimonial.currentRecordedBlob;
export const getTestimonialSubmitDisabled = (state) => state.testimonial.testimonialSubmitDisabled;
export const getRole = (state) => state.testimonial.role;
export const getCandidateName = (state) => state.testimonial.candidateName;
export const getRecordings = (state) => state.testimonial.recordings;

export default testimonialSlice.reducer;
